import React, { useState } from 'react';
import './navbar.scss';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { useWeb3React } from '@web3-react/core';
import useAuth from '../../../hooks/useAuth';
import { NavLink } from 'react-router-dom';

const Navbar = () => {

    const { login, logout } = useAuth();
    const { account } = useWeb3React();


    const [open, Close] = useState(true);

    const connectMetamask = () => {
        localStorage.setItem('connectorId', 'injected');
        if (account) {
            logout();
        } else {
            login('injected');
        }
    };



    const showModal = () => {
        window.$("#exampleModal").modal('show');
    }
    const disconnect = () => {
        logout()
    }

    const Disconnect = async () => {
        logout();
        localStorage.setItem('connectorId', '');
    };


    return (
        <section className="main-navbar">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-11 mx-auto">
                        {/* mobile */}
                        {/* <nav className="navbar d-block d-lg-none w-100 queryFlex navbar-expand-lg ">
                            <a className="navbar-brand" href="/">
                                <img src="hash-max-assets/header/logo.png" className="img-fluid logoIMg" alt="" />
                            </a>
                            <button onClick={() => Close(true)} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <div class="style-bar"></div>
                                <div class="style-bar"></div>
                                <div class="style-bar"></div>
                            </button>
                            {open && <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul className="navbar-nav mr-auto">
                                    <li className="nav-item">
                                        <HashLink className="nav-link my-1 " to="#collection">
                                            Collection
                                        </HashLink>
                                    </li>
                                    <li className="nav-item">
                                        <HashLink className="nav-link my-1 " to="#roadmap">
                                            Roadmap
                                        </HashLink>
                                    </li>
                                    <li className="nav-item">
                                        <HashLink className="nav-link my-1 " to="#team">
                                            Staking
                                        </HashLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link my-1 " to="/merch" >
                                            Merch
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link my-1 " to="/nftperks">
                                            NFT perks
                                        </NavLink>
                                    </li>
                                </ul>
                                <form className="form-inline my-2 my-lg-0">
                                    <a className="">
                                        <img src="hash-max-assets/header/twitter-icon.svg" className="img-fluid socialHeight" alt="" />
                                    </a>
                                    <a className="">
                                        <img src="hash-max-assets/header/discord-icon.svg" className="img-fluid socialHeight" alt="" />
                                    </a>
                                    <a className="">
                                        <img src="hash-max-assets/header/instagram-icon.svg" className="img-fluid socialHeight" alt="" />
                                    </a>
                                </form>
                            </div>
                            }
                        </nav> */}
                        {/* mobile */}
                        {/* laptop */}
                        <nav className="navbar   navbar-expand-lg ">
                            <Link className="navbar-brand" to="/">
                                <img src="hash-max-assets/header/logo.png" className="img-fluid logoIMg" alt="" />
                            </Link>
                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <div class="style-bar"></div>
                                <div class="style-bar"></div>
                                <div class="style-bar"></div>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul className="navbar-nav mx-auto">
                                    <li className="nav-item">
                                        <HashLink className="nav-link " to="#collection">
                                            Collection
                                        </HashLink>
                                    </li>
                                    <li className="nav-item">
                                        <HashLink className="nav-link " to="#roadmap">
                                            Roadmap
                                        </HashLink>
                                    </li>
                                    <li className="nav-item">
                                        <HashLink className="nav-link " to="#team">
                                            Staking
                                        </HashLink>
                                    </li>
                                    <li className="nav-item">
                                        <Link exact className="nav-link " to="/merching"  >
                                            Merch
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link " to="/nftperks">
                                            NFT perks
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                    <Link className="nav-link " to="/minting">
                                          Mint
                                        </Link>
                                    </li>
                                    {/* <li className="nav-item">
                                <HashLink className="nav-link common" to="#content">
                                    mint 
                                </HashLink>
                            </li> */}
                                    
                                    {/* <li className="nav-item">
                                <HashLink className="nav-link common" to="#content">
                                    mint 
                                </HashLink>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link common" to="/mint">
                                    MINT
                                </Link>
                            </li> */}
                                </ul>
                                <div className="form-inline my-2 my-lg-0">
                                    <a className="">
                                        <img src="hash-max-assets/header/twitter-icon.svg" className="img-fluid socialHeight" alt="" />
                                    </a>
                                    <a className="">
                                        <img src="hash-max-assets/header/discord-icon.svg" className="img-fluid socialHeight" alt="" />
                                    </a>
                                    <a className="">
                                        <img src="hash-max-assets/header/instagram-icon.svg" className="img-fluid socialHeight" alt="" />
                                    </a>
                                    {/* {
                                
                                    <button className="btn-common" onClick={showModal}>Connect Wallet</button> 
                                    // <button className="btn-common" onClick={Disconnect}>Disconnect Wallet</button>
                            } */}
                                </div>
                            </div>
                        </nav>
                        {/* laptop */}
                    </div>
                </div>

            </div>

            {/* <>
                <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title text-center w-100" id="exampleModalLabel">Connect Wallet</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"><img src="assets/errorSign.svg" alt="" /></button>
                            </div>
                            <div class="modal-body p-4 text-center">
                                <button className='w-100 ' type='button' onClick={connectMetamask}>
                                    <div className="row py-3">
                                        <div className="col-5 text-end">
                                            <img src="assets/metamask-logo.png" alt="" className='img-fluid' />
                                        </div>
                                        <div className="col-6 my-auto p-0 text-start">
                                            <p>Metamask</p>
                                        </div>
                                    </div>
                                </button>
                                <button className='w-100 mt-3' type='button' onClick={wallletconnect}>
                                    <div className="row py-3">
                                        <div className="col-5 text-end ">
                                            <img src="assets/walletconnect-logo.png" className='img-fluid' alt="" />
                                        </div>
                                        <div className="col-6 my-auto p-0 text-start">
                                            <p>WalletConnect</p>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </> */}
        </section>
    )
}

export default Navbar;
